module.exports = __webpack_public_path__ + "img/coghent.124bdf1d.svg";